import { Typography } from "@mui/material";
import { FC } from "react";
import Container from "../../components/UI/Container";

const GalleryPage: FC = () => {
  return (
    <Container>
      <Typography color="primary" textAlign="center" variant="h3">
        Gallery Page
      </Typography>
    </Container>
  );
};

export default GalleryPage;
